import { render, staticRenderFns } from "./AddressFields.vue?vue&type=template&id=70135a1a&scoped=true"
import script from "./AddressFields.vue?vue&type=script&lang=js"
export * from "./AddressFields.vue?vue&type=script&lang=js"
import style0 from "./AddressFields.vue?vue&type=style&index=0&id=70135a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70135a1a",
  null
  
)

export default component.exports